import { render, staticRenderFns } from "./Addon.vue?vue&type=template&id=a8eb5782"
import script from "./Addon.vue?vue&type=script&lang=js"
export * from "./Addon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports